import * as React from 'react';
import { arrow, offset, flip, safePolygon, shift, autoUpdate, useFloating, useInteractions, useHover, useFocus, useRole, useDismiss, } from '@floating-ui/react-dom-interactions';
import TooltipBase from './TooltipBase';
// The opposite side of the arrow, for styling
export const arrowStaticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
};
const Tooltip = ({ children, content, placement = 'top', offset: _offset = 0, floatingElementProps = {}, hideArrow = false, delay = {
    close: 100,
}, }) => {
    const [open, setOpen] = React.useState(false);
    const arrowRef = React.useRef(null);
    const middleware = [offset(_offset), flip(), shift({ padding: 8 })];
    if (!hideArrow) {
        middleware.push(arrow({ element: arrowRef }));
    }
    const { x, y, floating, reference, strategy, context, refs, middlewareData: { arrow: { x: arrowX = null, y: arrowY = null } = {} }, placement: calculatedPlacement, } = useFloating({
        placement,
        open,
        onOpenChange: setOpen,
        middleware,
        whileElementsMounted: autoUpdate,
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useHover(context, {
            enabled: !!content,
            delay,
            handleClose: safePolygon({ restMs: 25 }),
        }),
        useFocus(context),
        useRole(context, { role: 'tooltip' }),
        useDismiss(context),
    ]);
    const { dataHook = 'tooltip-content', className, arrowClassName, ...restFloatingElementProps } = floatingElementProps;
    const getChildren = () => {
        if (typeof children === 'function') {
            return React.cloneElement(children(refs), getReferenceProps({ ...children(refs).props, ref: reference }));
        }
        return React.cloneElement(children, getReferenceProps({ ...children.props, ref: reference }));
    };
    return (React.createElement(TooltipBase, { arrowProps: {
            className: arrowClassName,
            'data-arrow-placement': calculatedPlacement,
            style: {
                left: arrowX != null ? `${arrowX}px` : '',
                top: arrowY != null ? `${arrowY}px` : '',
                [arrowStaticSide[calculatedPlacement.split('-')[0]]]: '0px',
            },
            ref: arrowRef,
        }, floatingProps: {
            ...getFloatingProps({
                ref: floating,
                className: 'Tooltip',
                style: {
                    position: strategy,
                    top: y ?? '',
                    left: x ?? '',
                },
            }),
            ...restFloatingElementProps,
            'data-hook': dataHook,
            className,
        }, open: open, content: content }, getChildren()));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map